// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3AEri","label":"Labeled_label__IBAwN","divider":"Labeled_divider__25ZFe"};